module.exports = __webpack_public_path__ + "static/media/BIS.bcbc8309.png";